import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import { DetailsCard } from "components";
import printJS from "lib/print-js";
import { CommunicationLogReplacementCar } from "modules/AppointmentDetails/components/CommunicationLogReplacementCar";
import { AppointmentDetails, Communications } from "modules/AppointmentDetails/components/KeylockerCommunicationLog/components";
import "modules/AppointmentDetails/components/KeylockerCommunicationLog/KeylockerCommunicationLog.scss";

import type { Appointment } from "models";

type KeylockerCommunicationLogProps = {
  appointment: Appointment;
};

export const KeylockerCommunicationLog = ({ appointment }: KeylockerCommunicationLogProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const handleToggleIsModalOpen = (evt: React.MouseEvent) => {
    evt.stopPropagation();

    setIsModalOpen(!isModalOpen);
  };

  const handlePrint = () =>
    printJS({
      printable: "keylocker-communication-log",
      type: "html",
      copyStyles: true,
      css: ["./KeylockerCommunicationLog.css"],
      scanStyles: false,
      targetStyles: ["*"]
    });

  const { keylocker_communications } = appointment;

  if (!keylocker_communications?.length) return null;

  return (
    <>
      <div className="KeylockerCommunicationLog" onClick={handleToggleIsModalOpen}>
        <DetailsCard title={t("v8_keylocker_comm_log", "Keylocker Communication Log")} icon="user" rightContent={null} showExpandArrow={false} button />
      </div>
      <Modal open={isModalOpen}>
        <Modal.Header className="KeylockerCommunicationLogHeader">
          <div className="header-title">
            <Icon name="list" />
            <div>{t("v8_keylocker_comm_log", "Keylocker communication log")}</div>
          </div>
          <Button onClick={handlePrint} className="action-btn" color="green">
            {t("v8_print", "Print")}
            <Icon className="print" />
          </Button>
        </Modal.Header>

        <Modal.Content className="KeylockerCommunicationLogContent" id="keylocker-communication-log" scrolling>
          <AppointmentDetails appointment={appointment} />
          <CommunicationLogReplacementCar appointment={appointment} />

          <Communications appointment={appointment} keylocker_communications={keylocker_communications} />
        </Modal.Content>

        <Modal.Actions className="KeylockerCommunicationLogActions">
          <Button className="action-btn" color="grey" onClick={handleToggleIsModalOpen} floated="right">
            {t("v8_close", "Close")}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
